export const planningGroupKey = (schedule) => JSON.stringify([
  schedule.worksite_id || schedule.id,
  schedule.team_leader_id || schedule.collaborator_id || schedule.id,
  schedule.start_date || schedule.date,
  schedule.end_date || schedule.start_date || schedule.date,
  schedule.time || '',
  schedule.end_time || '',
  schedule.shift || '',
  schedule.description || '',
]);

export const fetchPlanningSchedules = async (client, url, config = {}) => {
  const data = [];
  const pageSize = 500;
  for (let offset = 0; ; offset += pageSize) {
    const response = await client.get(url, {
      ...config,
      params: { ...config.params, limit: pageSize, offset },
    });
    const rows = response.data || [];
    data.push(...rows);
    if (rows.length < pageSize) return { data };
  }
};

export const expandPlanningOverrides = (schedules, overrides) => {
  const expanded = new Map();
  overrides.filter(override => ['postpone', 'cancel'].includes(override.override_type)).forEach(override => {
    const base = schedules.find(schedule => schedule.id === override.schedule_id);
    if (!base) return;
    const groupKey = planningGroupKey(base);
    schedules.filter(schedule => planningGroupKey(schedule) === groupKey).forEach(schedule => {
      const key = `${schedule.id}_${override.original_date}`;
      if (!expanded.has(key) || schedule.id === override.schedule_id) {
        expanded.set(key, { ...override, schedule_id: schedule.id });
      }
    });
  });
  return [...expanded.values()];
};

export const groupTechnicianMissions = (missions, technicianId) => {
  const grouped = new Map();
  missions.forEach(mission => {
    const key = `${planningGroupKey(mission)}_${mission.status}`;
    const existing = grouped.get(key);
    if (!existing || mission.collaborator_id === technicianId) grouped.set(key, mission);
  });
  return [...grouped.values()];
};